// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {areFieldsValid} from '../form-field-validators/verify-required-fields';

export const updateFormValidation = () => (dispatch, getState) =>
    dispatch({
        isFormValid: areFieldsValid(getState().pips.pipCodeRequest.pipCode),
        type: actions.UPDATE_FORM_VALIDATION_STATE
    });



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/form-validation.js